<div class="input-group">
    <input  class="form-control w-100" id="{{id}}"
        placeholder="{{placeholder}}" (keydown)="catchKeydown($event)"
        [(ngModel)]="amountText" [disabled]="disabled"
        (ngModelChange)="changeValue()"
        />
    <span class="input-unit" *ngIf="unit">{{unit}}</span>
</div>